/**
 * SHOEV Animations - singleton IntersectionObserver reveal system.
 * Repeated section includes refresh the singleton instead of adding observers/listeners.
 */
(function () {
  'use strict';

  if (window.ShoevAnimations && typeof window.ShoevAnimations.refresh === 'function') {
    window.ShoevAnimations.refresh(document);
    return;
  }

  var supportsObserver = typeof IntersectionObserver !== 'undefined';
  var observer = null;

  function reveal(element) {
    element.classList.add('is-visible');
  }

  function revealElements(scope) {
    var elements = [];
    if (scope.matches && scope.matches('.shoev-reveal:not(.is-visible)')) elements.push(scope);
    scope.querySelectorAll('.shoev-reveal:not(.is-visible)').forEach(function (element) {
      elements.push(element);
    });
    return elements;
  }

  function applyStaggers(scope) {
    var groups = [];
    if (scope.matches && scope.matches('[data-stagger]')) groups.push(scope);
    scope.querySelectorAll('[data-stagger]').forEach(function (group) {
      groups.push(group);
    });

    groups.forEach(function (group) {
      var stagger = parseInt(group.getAttribute('data-stagger') || '0', 10);
      if (!stagger) return;
      Array.prototype.forEach.call(group.children, function (child, index) {
        var revealChild = child.classList.contains('shoev-reveal') ? child : child.querySelector('.shoev-reveal');
        if (revealChild) revealChild.style.setProperty('--shoev-stagger', String(index * stagger));
      });
    });
  }

  function refresh(scope) {
    scope = scope && scope.querySelectorAll ? scope : document;
    applyStaggers(scope);
    revealElements(scope).forEach(function (element) {
      if (supportsObserver) observer.observe(element);
      else reveal(element);
    });
  }

  function unobserve(scope) {
    if (!observer || !scope || !scope.querySelectorAll) return;
    if (scope.matches && scope.matches('.shoev-reveal')) observer.unobserve(scope);
    scope.querySelectorAll('.shoev-reveal').forEach(function (element) {
      observer.unobserve(element);
    });
  }

  if (supportsObserver) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var element = entry.target;
          element.style.setProperty('--shoev-stagger', element.getAttribute('data-delay') || element.style.getPropertyValue('--shoev-stagger') || '0');
          reveal(element);
          observer.unobserve(element);
        });
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0.1 }
    );
  }

  window.ShoevAnimations = {
    refresh: refresh,
    unobserve: unobserve
  };

  refresh(document);
  if (supportsObserver) document.documentElement.classList.add('shoev-animations-ready');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      refresh(document);
    }, { once: true });
  }

  document.addEventListener('shopify:section:load', function (event) {
    refresh(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    unobserve(event.target);
  });
})();
